import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { LineHeightProps, WidthProps } from 'styled-system';
import {
  borderRadius,
  color,
  fontSize,
  lineHeight,
  space,
  textAlign,
  themeGet,
  width,
} from 'styled-system';

import type { SpaceProps } from '../../theme/system-types';
import type {
  TextDecorationProps,
  TextDecorationThicknessProps,
  TextTransformProps,
} from '../../theme/system-utilities';
import {
  textDecoration,
  textDecorationThickness,
  textUnderlinePosition,
} from '../../theme/system-utilities';
import { Button } from './index';

export const StyledButton = styled(Button)<
  SpaceProps &
    TextDecorationProps &
    TextTransformProps &
    WidthProps &
    TextDecorationThicknessProps &
    LineHeightProps
>`
  ${space};
  ${color};
  ${width};
  ${fontSize};
  ${textAlign};
  ${lineHeight};
  ${borderRadius};
  ${textDecoration};
  ${textUnderlinePosition};
  ${textDecorationThickness};

  &[aria-disabled='true'] {
    cursor: not-allowed;
    color: ${themeGet('colors.sys.neutral.text.inactive')};
  }
`;

const buttonStyles = {
  textAlign: 'left',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  borderRadius: 'medium',
  textDecoration: 'underline',
  color: 'sys.neutral.text.strong',
  textUnderlinePosition: 'from-font',
  textDecorationThickness: 'from-font',
} as const;

export const LinkButton = (props: ComponentProps<typeof StyledButton>) => {
  return <StyledButton kind="bare" {...buttonStyles} {...props} />;
};
